export default __webpack_public_path__ + "static/media/404.59638b90.gif";